import { render } from "./MainProductsUnitMeasure.vue?vue&type=template&id=f251d088"
import script from "./MainProductsUnitMeasure.vue?vue&type=script&lang=js"
export * from "./MainProductsUnitMeasure.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__